var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAmexLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 32 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "#006fcf",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M16.93 19.98v-8.47l15.07.02v2.34l-1.74 1.86L32 17.6v2.38h-2.78l-1.48-1.63L26.27 20z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M17.64 4h3.63l1.27 2.9V4h4.49l.77 2.17.78-2.17H32v8.47H13.9L17.65 4Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#006fcf",
  fillRule: "evenodd",
  d: "M17.94 19.05v-6.6h5.6v1.52h-3.79V15h3.7v1.5h-3.7v1.01h3.79v1.54z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#006fcf",
  fillRule: "evenodd",
  d: "m23.51 19.05 3.1-3.3-3.1-3.3h2.4l1.9 2.09 1.9-2.1H32v.06l-3.03 3.24L32 18.96v.1h-2.32l-1.93-2.12-1.9 2.11H23.5ZM18.32 4.92l-2.93 6.6h2.01l.55-1.32h3l.55 1.32h2.06l-2.91-6.6zm.25 3.8.88-2.1.88 2.1zm4.97 2.8v-6.6h2.82L27.82 9l1.46-4.07H32v6.6l-1.75.01V7l-1.65 4.52H27l-1.69-4.54v4.54z",
  clipRule: "evenodd"
})));
export default SvgAmexLight;